export default {
  props: {
    params: {
      type: Object,
      required: false
    },
    item: {
      type: String,
      required: true
    },
    selected: {
      required: false
    }
  },
  computed: {
    showSelected () {
      return this.selected === this.item;
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/listItemMixin.js